<template>
    <video ref="videoPlayer" class="video-js" :playsinline="playsinline"></video>
</template>

<script>
import videojs from 'video.js';

export default {
  name: "VideoPlayer",

  props: {
    playsinline: Boolean,
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {
      player: null
    }
  },

mounted() {
    // 再次確保全域沒有人佔用這個 ID
    const existingPlayer = videojs.getPlayer(this.$refs.videoPlayer);
    if (existingPlayer) {
        existingPlayer.dispose();
    }

    this.player = videojs(this.$refs.videoPlayer, this.options, function() {
        console.log('Video.js 8 Ready');
    });
},

  beforeDestroy() {
    // 徹底銷毀播放器，防止記憶體洩漏
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
  }
}
</script>

<style scoped>

</style>

<style lang="scss" scoped>
  // 刪除原本在這裡的所有 .vjs-resolution-button 相關樣式
</style>
